"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icons = void 0;

var _Home = _interopRequireDefault(require("./Home"));

var _Search = _interopRequireDefault(require("./Search"));

var _Plus = _interopRequireDefault(require("./Plus"));

var _PlusThin = _interopRequireDefault(require("./PlusThin"));

var _Minus = _interopRequireDefault(require("./Minus"));

var _MyProfile = _interopRequireDefault(require("./MyProfile"));

var _LinkedIn = _interopRequireDefault(require("./LinkedIn"));

var _Youtube = _interopRequireDefault(require("./Youtube"));

var _Twitter = _interopRequireDefault(require("./Twitter"));

var _Facebook = _interopRequireDefault(require("./Facebook"));

var _Instagram = _interopRequireDefault(require("./Instagram"));

var _Cart = _interopRequireDefault(require("./Cart"));

var _Hamburger = _interopRequireDefault(require("./Hamburger"));

var _Language = _interopRequireDefault(require("./Language"));

var _Country = _interopRequireDefault(require("./Country"));

var _VerticalDivider = _interopRequireDefault(require("./VerticalDivider"));

var _Support = _interopRequireDefault(require("./Support"));

var _XoxoPoints = _interopRequireDefault(require("./XoxoPoints"));

var _XoxoCode = _interopRequireDefault(require("./XoxoCode"));

var _ExternalLink = _interopRequireDefault(require("./ExternalLink"));

var _Check = _interopRequireDefault(require("./Check"));

var _Cross = _interopRequireDefault(require("./Cross"));

var _ChevronUp = _interopRequireDefault(require("./ChevronUp"));

var _ChevronDown = _interopRequireDefault(require("./ChevronDown"));

var _ChevronLeft = _interopRequireDefault(require("./ChevronLeft"));

var _ChevronRight = _interopRequireDefault(require("./ChevronRight"));

var _ErrorCircle = _interopRequireDefault(require("./ErrorCircle"));

var _WarningFilled = _interopRequireDefault(require("./WarningFilled"));

var _CheckFilled = _interopRequireDefault(require("./CheckFilled"));

var _DropdownArrow = _interopRequireDefault(require("./DropdownArrow"));

var _Close = _interopRequireDefault(require("./Close"));

var _AddToCart = _interopRequireDefault(require("./AddToCart"));

var _CartFilled = _interopRequireDefault(require("./CartFilled"));

var _Mail = _interopRequireDefault(require("./Mail"));

var _PriceLabel = _interopRequireDefault(require("./PriceLabel"));

var _ShoppingBag = _interopRequireDefault(require("./ShoppingBag"));

var _CartWithDot = _interopRequireDefault(require("./CartWithDot"));

var _Filter = _interopRequireDefault(require("./Filter"));

var _PlusCircle = _interopRequireDefault(require("./PlusCircle"));

var _InfoCircle = _interopRequireDefault(require("./InfoCircle"));

var _CoinsHand = _interopRequireDefault(require("./CoinsHand"));

var _Share = _interopRequireDefault(require("./Share"));

var _Eye = _interopRequireDefault(require("./Eye"));

var _EyeHide = _interopRequireDefault(require("./EyeHide"));

var _Trash = _interopRequireDefault(require("./Trash"));

var _Expand = _interopRequireDefault(require("./Expand"));

var _Edit = _interopRequireDefault(require("./Edit"));

var _Link = _interopRequireDefault(require("./Link"));

var _Alert = _interopRequireDefault(require("./Alert"));

var _Unlocked = _interopRequireDefault(require("./Unlocked"));

var _Lock = _interopRequireDefault(require("./Lock"));

var _Calender = _interopRequireDefault(require("./Calender"));

var _Download = _interopRequireDefault(require("./Download"));

var _DropdownHorizontal = _interopRequireDefault(require("./DropdownHorizontal"));

var _Setting = _interopRequireDefault(require("./Setting"));

var _LinkBroken = _interopRequireDefault(require("./LinkBroken"));

var _Wallet = _interopRequireDefault(require("./Wallet"));

var _CheckCircle = _interopRequireDefault(require("./CheckCircle"));

var _MinusCircle = _interopRequireDefault(require("./MinusCircle"));

var _CloseCircle = _interopRequireDefault(require("./CloseCircle"));

var _ArrowCircleBroken = _interopRequireDefault(require("./ArrowCircleBroken"));

var _ReceiptCheck = _interopRequireDefault(require("./ReceiptCheck"));

var _Sale = _interopRequireDefault(require("./Sale"));

var _Gift = _interopRequireDefault(require("./Gift"));

var _Bank = _interopRequireDefault(require("./Bank"));

var _CreditCard = _interopRequireDefault(require("./CreditCard"));

var _ShieldTick = _interopRequireDefault(require("./ShieldTick"));

var _LightBulb = _interopRequireDefault(require("./LightBulb"));

var _ZoomOut = _interopRequireDefault(require("./ZoomOut"));

var _ZoomIn = _interopRequireDefault(require("./ZoomIn"));

var _ArrowRight = _interopRequireDefault(require("./ArrowRight"));

var _ArrowLeft = _interopRequireDefault(require("./ArrowLeft"));

var _ArrowUp = _interopRequireDefault(require("./ArrowUp"));

var _ArrowDown = _interopRequireDefault(require("./ArrowDown"));

var _AlarmClock = _interopRequireDefault(require("./AlarmClock"));

var _Refresh = _interopRequireDefault(require("./Refresh"));

var _SwitchHorizontal = _interopRequireDefault(require("./SwitchHorizontal"));

var _DotPoints = _interopRequireDefault(require("./DotPoints"));

var _Image = _interopRequireDefault(require("./Image"));

var _MessageNotification = _interopRequireDefault(require("./MessageNotification"));

var _Whatsapp = _interopRequireDefault(require("./Whatsapp"));

var _LoadingSpin = _interopRequireDefault(require("./LoadingSpin"));

var _Voucher = _interopRequireDefault(require("./Voucher"));

var _Experience = _interopRequireDefault(require("./Experience"));

var _Merchandise = _interopRequireDefault(require("./Merchandise"));

var _Clock = _interopRequireDefault(require("./Clock"));

var _Puzzle = _interopRequireDefault(require("./Puzzle"));

var _UserGroup = _interopRequireDefault(require("./UserGroup"));

var _Direction = _interopRequireDefault(require("./Direction"));

var _System = _interopRequireDefault(require("./System"));

var _History = _interopRequireDefault(require("./History"));

var Icons = {
  Home: _Home["default"],
  Cart: _Cart["default"],
  MyProfile: _MyProfile["default"],
  Hamburger: _Hamburger["default"],
  Language: _Language["default"],
  Country: _Country["default"],
  VerticalDivider: _VerticalDivider["default"],
  Support: _Support["default"],
  Search: _Search["default"],
  XoxoPoints: _XoxoPoints["default"],
  XoxoCode: _XoxoCode["default"],
  LinkedIn: _LinkedIn["default"],
  Youtube: _Youtube["default"],
  Twitter: _Twitter["default"],
  Facebook: _Facebook["default"],
  Instagram: _Instagram["default"],
  ExternalLink: _ExternalLink["default"],
  Check: _Check["default"],
  Cross: _Cross["default"],
  ChevronUp: _ChevronUp["default"],
  ChevronDown: _ChevronDown["default"],
  ChevronRight: _ChevronRight["default"],
  ChevronLeft: _ChevronLeft["default"],
  ErrorCircle: _ErrorCircle["default"],
  WarningFilled: _WarningFilled["default"],
  CheckFilled: _CheckFilled["default"],
  DropdownArrow: _DropdownArrow["default"],
  Plus: _Plus["default"],
  Minus: _Minus["default"],
  Close: _Close["default"],
  PlusThin: _PlusThin["default"],
  AddToCart: _AddToCart["default"],
  CartFilled: _CartFilled["default"],
  Mail: _Mail["default"],
  PriceLabel: _PriceLabel["default"],
  ShoppingBag: _ShoppingBag["default"],
  CartWithDot: _CartWithDot["default"],
  Filter: _Filter["default"],
  PlusCircle: _PlusCircle["default"],
  InfoCircle: _InfoCircle["default"],
  CoinsHand: _CoinsHand["default"],
  Share: _Share["default"],
  Eye: _Eye["default"],
  EyeHide: _EyeHide["default"],
  Trash: _Trash["default"],
  Expand: _Expand["default"],
  Edit: _Edit["default"],
  Link: _Link["default"],
  Alert: _Alert["default"],
  Unlocked: _Unlocked["default"],
  Lock: _Lock["default"],
  Calender: _Calender["default"],
  Download: _Download["default"],
  DropdownHorizontal: _DropdownHorizontal["default"],
  Setting: _Setting["default"],
  LinkBroken: _LinkBroken["default"],
  Wallet: _Wallet["default"],
  CheckCircle: _CheckCircle["default"],
  MinusCircle: _MinusCircle["default"],
  CloseCircle: _CloseCircle["default"],
  ArrowCircleBroken: _ArrowCircleBroken["default"],
  ReceiptCheck: _ReceiptCheck["default"],
  Sale: _Sale["default"],
  Gift: _Gift["default"],
  Bank: _Bank["default"],
  CreditCard: _CreditCard["default"],
  ShieldTick: _ShieldTick["default"],
  LightBulb: _LightBulb["default"],
  ZoomOut: _ZoomOut["default"],
  ZoomIn: _ZoomIn["default"],
  ArrowLeft: _ArrowLeft["default"],
  ArrowRight: _ArrowRight["default"],
  ArrowUp: _ArrowUp["default"],
  ArrowDown: _ArrowDown["default"],
  AlarmClock: _AlarmClock["default"],
  Refresh: _Refresh["default"],
  SwitchHorizontal: _SwitchHorizontal["default"],
  DotPoints: _DotPoints["default"],
  Image: _Image["default"],
  MessageNotification: _MessageNotification["default"],
  Whatsapp: _Whatsapp["default"],
  LoadingSpin: _LoadingSpin["default"],
  Voucher: _Voucher["default"],
  Experience: _Experience["default"],
  Merchandise: _Merchandise["default"],
  Clock: _Clock["default"],
  Puzzle: _Puzzle["default"],
  UserGroup: _UserGroup["default"],
  Direction: _Direction["default"],
  System: _System["default"],
  History: _History["default"]
};
exports.Icons = Icons;